<dialog [id]="modalDialogId" class="modal">
    <div
        class="modal-box p-5 max-w-[1000px] mobile:max-w-[90vw] max-h-[90dvh] overflow-y-auto flex flex-wrap gap-5">
        <div class="flex-[1] flex flex-col gap-2">
            <!-- Logo -->
            <div class="flex flex-wrap gap-2">
                <img src="assets/icons/small-logo.svg" class="w-[80px] h-[80px]"
                    alt="{{ 'shared.components.logo_alt' | transloco}}">
                <div class="flex flex-col gap-1">
                    <h1 class="text-bold font-extrabold text-4xl">{{ selectedPaymentPlan?.title ?? '' }}</h1>
                    <p class="font-normal">
                        <a routerLink="/settings/plans" (click)="closeModal()" class="text-primary hover:underline">
                            {{ 'shared.change_plan' | transloco }}
                        </a>
                    </p>
                </div>
            </div>
            @if (!userNeedsToPay)
            {
            <!-- Payment fee -->
            <div class="min-w-[300px]">
                <app-custom-dropdown [options]="planPayOptions" [(selectedOption)]="planPayOptionSelected"
                    (selectedOptionChange)="changeSubscriptionUpdatePrice()"
                    label="{{ 'shared.labels.billing.package_fee' | transloco }}"
                    placeholder="{{ 'shared.placeholders.billing.package_fee' | transloco }}"
                    boxHeight="h-[5vh] min-h-[50px] max-h-[70px]">
                </app-custom-dropdown>
            </div>

            <p *ngIf="showPriceSummary" class="text-neutral-800">{{ 'shared.payment_dialog.account_includes' | transloco
                }} <span class="font-bold">{{numberOfLocations}}</span> {{
                'shared.payment_dialog.locations_each_charged' |
                transloco }} <span class="font-bold">{{pricePerLocation}}€</span>.
                {{ 'shared.payment_dialog.please_review' | transloco }}
            </p>
            <!-- Shimmer -->
            <div class="animate-pulse" *ngIf="!showPriceSummary">
                <div class="h-[50px] w-full bg-neutral-300 rounded-md"></div>
            </div>

            <!-- Billing information -->
            <p class="text-neutral-800 font-semibold mobile:text-sm mt-5">
                {{ 'shared.labels.billing_information' | transloco }}
            </p>

            <!-- Email -->
            <div class="flex-[1] min-w-[300px] mobile:w-full">
                <app-labeled-input labelText="{{ 'shared.labels.billing.email' | transloco }}" [inputId]="'email'"
                    [inputType]="'email'" [(inputValue)]="billingEmail" [errorMessage]="billingEmailError"
                    placeholder="{{ 'shared.placeholders.billing.email' | transloco }}"
                    boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="isInputDisabled"></app-labeled-input>
            </div>

            <!-- Name -->
            <div class="flex-[1] min-w-[300px] mobile:w-full">
                <app-labeled-input labelText="{{ 'shared.labels.billing.name' | transloco }}" [inputId]="'name'"
                    [inputType]="'text'" [(inputValue)]="billingName" [errorMessage]="billingNameError"
                    placeholder="{{ 'shared.placeholders.billing.name' | transloco }}"
                    boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="isInputDisabled"></app-labeled-input>
            </div>

            <!-- City -->
            <div class="flex-[1] min-w-[300px] mobile:w-full">
                <app-labeled-input labelText="{{ 'shared.labels.billing.city' | transloco }}" [inputId]="'city'"
                    [inputType]="'text'" [(inputValue)]="billingCity" [errorMessage]="billingCityError"
                    placeholder="{{ 'shared.placeholders.billing.city' | transloco }}"
                    boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="isInputDisabled"></app-labeled-input>
            </div>

            <!-- Country -->
            <div class="flex-[1] min-w-[300px] mobile:w-full">
                <app-custom-dropdown [options]="countriesDropdownOptions" [(selectedOption)]="selectedCountry"
                    label="{{ 'shared.labels.billing.country_code' | transloco }}"
                    placeholder="{{ 'shared.placeholders.billing.country_code' | transloco }}"
                    boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [disabled]="isInputDisabled"
                    [errorMessage]="selectedCountryError">
                </app-custom-dropdown>
            </div>

            <!-- Address -->
            <div class="flex-[1] min-w-[300px] mobile:w-full">
                <app-labeled-input labelText="{{ 'shared.labels.billing.address' | transloco }}" [inputId]="'address'"
                    [inputType]="'text'" [(inputValue)]="billingAddress" [errorMessage]="billingAddressError"
                    placeholder="{{ 'shared.placeholders.billing.address' | transloco }}"
                    boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="isInputDisabled"></app-labeled-input>
            </div>

            <!-- Postal Code -->
            <div class="flex-[1] min-w-[300px] mobile:w-full">
                <app-labeled-input labelText="{{ 'shared.labels.billing.postal_code' | transloco }}"
                    [inputId]="'postal_code'" [inputType]="'text'" [(inputValue)]="billingPostalCode"
                    [errorMessage]="billingPostalCodeError"
                    placeholder="{{ 'shared.placeholders.billing.postal_code' | transloco }}"
                    boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="isInputDisabled"></app-labeled-input>
            </div>

            <!-- State -->
            <div class="flex-[1] min-w-[300px] mobile:w-full">
                <app-labeled-input labelText="{{ 'shared.labels.billing.state' | transloco }}" [inputId]="'state'"
                    [inputType]="'text'" [(inputValue)]="billingState" [errorMessage]="billingStateError"
                    placeholder="{{ 'shared.placeholders.billing.state' | transloco }}"
                    boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="isInputDisabled"></app-labeled-input>
            </div>

            <!-- PEC Email Address -->
            <app-labeled-input labelText="{{ 'shared.labels.billing.pec_email_address' | transloco }}"
                [inputId]="'pec_email_address'" [inputType]="'text'" [(inputValue)]="billingPecEmailAddress"
                [errorMessage]="billingPecEmailAddressError"
                placeholder="{{ 'shared.placeholders.billing.pec_email_address' | transloco }}"
                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="isInputDisabled"></app-labeled-input>

            <!-- SDI -->
            <app-labeled-input labelText="{{ 'shared.labels.billing.sdi' | transloco }}" [inputId]="'sdi'"
                [inputType]="'text'" [(inputValue)]="billingSdi" [errorMessage]="billingSdiError"
                placeholder="{{ 'shared.placeholders.billing.sdi' | transloco }}"
                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="isInputDisabled"></app-labeled-input>

            <!-- VAT ID -->
            <app-labeled-input labelText="{{ 'shared.labels.billing.vat_id' | transloco }}" [inputId]="'vat_id'"
                [inputType]="'text'" [(inputValue)]="billingVatId" [errorMessage]="billingVatIdError"
                placeholder="{{ 'shared.placeholders.billing.vat_id' | transloco }}"
                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="isInputDisabled"></app-labeled-input>
            }
            @else if(subscriptionGet && subscriptionGet.client_secret != null) {
            <div class="w-full">
                @if (!isUserOnTrial) {
                <app-payment [clientSecret]="subscriptionGet.client_secret" [isPayment]="!isEligibleForTrial"></app-payment>
                }
                @else {
                <app-payment-method-update [clientSecret]="subscriptionGet.client_secret"></app-payment-method-update>
                }
            </div>
            }
        </div>

        <div class="flex-[1] p-2">
            <div
                class="w-full min-h-[500px] bg-primary-200 rounded-[16px] p-5 flex flex-col gap-5 justify-between desktop:mt-[40px]">
                <div class="flex flex-col gap-5">
                    <p class="text-neutral-800 font-bold text-xl mobile:text-sm mt-5">
                        {{ 'shared.summary' | transloco }}
                    </p>
                    <div class="w-full h-[1px] bg-neutral-300"></div>

                    <div class="w-full flex flex-wrap gap-2 justify-between items-center">
                        @if (planPayOptionSelected === 0)
                        {
                        <p>{{ 'settings.billed_yearly' | transloco }} ( {{ selectedPaymentPlan?.title ?? '' }} )</p>
                        <p *ngIf="showPriceSummary" class="text-primary font-bold">{{
                            formatPrice(selectedPaymentPlan?.price_per_year)}}€</p>
                        <!-- Shimmer -->
                        <div class="animate-pulse" *ngIf="!showPriceSummary">
                            <div class="h-6 w-24 bg-neutral-300 rounded-md"></div>
                        </div>
                        }
                        @else if (planPayOptionSelected === 1)
                        {
                        <p>{{ 'settings.billed_monthly' | transloco }} ( {{
                            selectedPaymentPlan?.title ?? '' }} )</p>
                        <p *ngIf="showPriceSummary" class="text-primary font-bold">{{
                            formatPrice(selectedPaymentPlan?.price_per_month)}}€</p>
                        <!-- Shimmer -->
                        <div class="animate-pulse" *ngIf="!showPriceSummary">
                            <div class="h-6 w-24 bg-neutral-300 rounded-md"></div>
                        </div>
                        }
                    </div>

                    <div class="w-full flex flex-wrap gap-2 justify-between items-center">

                        <p *ngIf="showPriceSummary">{{numberOfLocations}} x {{ 'shared.labels.billing.location_fee' |
                            transloco }} (
                            {{pricePerLocation}}€ {{ ( (planPayOptionSelected === 0 ? true : false) ?
                            'settings.per_year' : 'settings.per_month') |
                            transloco }})</p>

                        <!-- Shimmer -->
                        <div class="animate-pulse" *ngIf="!showPriceSummary">
                            <div class="h-6 w-24 bg-neutral-300 rounded-md"></div>
                        </div>

                        <p *ngIf="showPriceSummary" class="text-primary font-bold">{{ formatPrice(getPriceForLocations)
                            }}€</p>

                        <!-- Shimmer -->
                        <div class="animate-pulse" *ngIf="!showPriceSummary">
                            <div class="h-6 w-24 bg-neutral-300 rounded-md"></div>
                        </div>

                    </div>
                    <div class="w-full flex flex-wrap gap-2 justify-between items-center">
                        <p>{{ 'shared.payment_dialog.subtotal' | transloco }}</p>
                        <p *ngIf="showPriceSummary" class="text-primary font-bold">{{ formatPrice(subtotal) }}€</p>
                        <!-- Shimmer -->
                        <div class="animate-pulse" *ngIf="!showPriceSummary">
                            <div class="h-6 w-24 bg-neutral-300 rounded-md"></div>
                        </div>
                    </div>
                    <div class="w-full flex flex-wrap gap-2 justify-between items-center">
                        <p>{{ 'shared.tax' | transloco }}</p>
                        <p *ngIf="showPriceSummary" class="text-primary font-bold">{{ formatPrice(tax) }}€</p>
                        <!-- Shimmer -->
                        <div class="animate-pulse" *ngIf="!showPriceSummary">
                            <div class="h-6 w-24 bg-neutral-300 rounded-md"></div>
                        </div>
                    </div>

                    <div class="w-full h-[1px] bg-neutral-300"></div>
                    <div class="w-full flex flex-wrap gap-2 justify-between items-center">
                        <p>{{ 'shared.payment_dialog.total_at_renewal' | transloco }}</p>
                        <p *ngIf="showPriceSummary" class="text-primary font-bold">{{ formatPrice(getTotalPrice) }}€</p>
                        <!-- Shimmer -->
                        <div class="animate-pulse" *ngIf="!showPriceSummary">
                            <div class="h-6 w-24 bg-neutral-300 rounded-md"></div>
                        </div>
                    </div>
                    <div class="w-full flex flex-wrap gap-2 justify-between items-center">
                        <p class="font-bold">{{ 'shared.payment_dialog.adjustment_due_today' | transloco }}</p>
                        <p *ngIf="showPriceSummary" class="text-primary font-bold">{{ formatPrice(getDueToday) }}€</p>
                        <!-- Shimmer -->
                        <div class="animate-pulse" *ngIf="!showPriceSummary">
                            <div class="h-6 w-24 bg-neutral-300 rounded-md"></div>
                        </div>
                    </div>

                    <!-- Discount Details -->
                    @if(promotionData && promotionDataLoaded && !userNeedsToPay)
                    {
                    <div class="w-full flex gap-2 items-center">
                        <p *ngIf="showPriceSummary" class="font-semibold">{{
                            getPromotionDescription(promotionData) }}</p>
                        <!-- Shimmer -->
                        <div class="animate-pulse" *ngIf="!showPriceSummary">
                            <div class="h-6 w-24 bg-neutral-300 rounded-md"></div>
                        </div>
                    </div>}

                    <!-- Trial Details -->
                    @if(isEligibleForTrial && !userNeedsToPay && showPriceSummary)
                    {
                    <div class="w-full flex gap-2 items-center p-4 rounded-xl bg-primary-400">
                        <p>{{ 'settings.trial_info' | transloco }}</p>
                    </div>}
                </div>

                @if(activeSubscription != undefined && selectedPaymentPlan?.id == activeSubscription.payment_plan_id &&
                (planPayOptionSelected === 0 ? true : false) == activeSubscription.billed_yearly) {
                <p class="text-error">{{ 'settings.subscription.already_subscribed' | transloco }}</p>
                }

                @if(showBillingInformationMissingError)
                {
                @if(!isInputDisabled)
                {
                <p class="text-error">{{ 'settings.subscription.customer_missing' | transloco }}</p>
                }
                @else
                {
                <p class="text-error">{{ 'settings.subscription.customer_missing_redirect' | transloco }} <a
                        routerLink="/settings/billing" class="text-primary hover:underline">
                        {{ 'shared.here' | transloco }}
                    </a>.</p>
                }
                }

                <div class="w-full h-[50px] items-center justify-center" *ngIf="!userNeedsToPay">
                    @if(activeSubscription == undefined)
                    {
                    <app-custom-button
                        [buttonText]="(continueClicked ? 'settings.subscription.creating_subscription' : 'shared.continue') | transloco"
                        backgroundColor="bg-primary" textColor="text-white" borderColor="border:bg-primary"
                        hoverBackgroundColor="hover:bg-primary-1200" (buttonClick)="onContinueClick()"
                        [showSpinner]="continueClicked" [isDisabled]="continueClicked"></app-custom-button>
                    }
                    @else {
                    <app-custom-button buttonText="{{'settings.subscription.manage' | transloco}}"
                        backgroundColor="bg-primary-700" textColor="text-white" borderColor="border:bg-primary-700"
                        hoverBorderColor="hover:border-primary-1200" hoverBackgroundColor="hover:bg-primary-1200"
                        (buttonClick)="openCustomerPanel()" [showSpinner]="openCustomerPanelButtonClicked"
                        [isDisabled]="openCustomerPanelButtonClicked"></app-custom-button>
                    }
                </div>
            </div>
        </div>
    </div>
    <form method="dialog" class="modal-backdrop">
        <button>Close</button>
    </form>
</dialog>